import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/button',
  title: 'DBAdmin - Button page',
  component: dynamicWrapper(app, [], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/UI/Button/index.js